import { Box } from "@storyofams/react-ui";
import { useState } from "react";
import { RichText } from "~components/common/RichText";
import { NhAccordion } from "~components/common/Story/NhComponents/NhAccordion";
import { ProductChoice } from "~components/product/Header/InfoAccordion/ProductChoice";
import useMediaQuery from "~hooks/useMediaQuery";
import { Bundle } from "./Bundle";
import { Ingredients } from "./Ingredients";

export const InfoAccordion = ({ content }) => {
  const bundlesIndex = content
    .filter(({ content }) => content)
    .findIndex(({ component }) => component === "bundle");
  const [isOpen, setIsOpen] = useState(
    bundlesIndex === -1 ? null : bundlesIndex
  );
  const close = () => setIsOpen(null);
  const scrollToTop = (i) => {
    const el = document?.getElementById(`${"top" + i}`);

    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  };
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  return (
    <Box>
      {content
        .filter(({ content }) => content)
        .map((item, i) => {
          switch (item.component) {
            case "bundle":
              return (
                <Box
                  key={i}
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion
                    close={isOpen !== i}
                    isOpen
                    isFirst
                    key={i}
                    title={`Deze bundel bestaat uit:`}
                  >
                    <Bundle content={{ ...item }} />
                  </NhAccordion>
                </Box>
              );
            case "accordion_text":
              return (
                <Box
                  key={i}
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion
                    key={i}
                    isFirst
                    title={item.title}
                    close={isOpen !== i}
                  >
                    <RichText
                      fontSize={2}
                      lineHeight={"22.4px"}
                      color="#1D1D1BCC"
                      text={item.content}
                    />
                  </NhAccordion>
                </Box>
              );
            case "accordion_ingredients":
              return (
                <Box
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  key={i}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion close={isOpen !== i} key={i} title={item.title}>
                    <Ingredients content={item.content} close={close} />
                  </NhAccordion>
                </Box>
              );
            case "product_choice":
              return (
                <Box
                  key={i}
                  id={"top" + i}
                  css={{
                    "scroll-margin-top": matchesMobile ? "50px" : "130px",
                  }}
                  onClick={() => {
                    if (isOpen === i) setIsOpen(false);
                    else {
                      setIsOpen(i);
                      scrollToTop(i);
                    }
                  }}
                >
                  <NhAccordion
                    close={isOpen !== i}
                    key={i}
                    title={"Personaliseer of maak het zelf"}
                  >
                    <ProductChoice
                      content={{ ...item, products: item.content }}
                    />
                  </NhAccordion>
                </Box>
              );
            default:
              return null;
          }
        })}
    </Box>
  );
};
